import React from "react";
import { observer } from "mobx-react-lite";

import { ICommand } from "Application";
import { Button, Show } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import { WeeklyRotaDetailsViewModel } from "../WeeklyRotaDetailViewModel";
import { StudentRota } from "../WeeklyRotaDetailModel";
import { Container, Footer, ButtonGroup, StyledDialog, Header, ViewStudentDetailsButton, SessionReportButton } from "./StudentRotaDetailView.styles";
import { SessionDetailsListView } from "./SessionDetailsListView";

export interface IProps {
    closeCommand: ICommand;
    viewModel: WeeklyRotaDetailsViewModel;
}

const StudentRotaDetailView: React.FC<IProps> = observer(({ closeCommand, viewModel }) => {
    const rota = viewModel.model.studentRota!;

    return (
        <Show if={viewModel.hasStudentRota}>
            <StyledDialog open={true}>
                <Header>
                    {rota.studentName}
                    <CloseIcon onClick={closeCommand.execute} />
                </Header>
                <Container>
                    <SessionDetailsListView rota={rota} viewModel={viewModel} />
                    <StudentRotaDetailFooter rota={rota} viewModel={viewModel} closeCommand={closeCommand} />
                </Container>
            </StyledDialog>
        </Show>
    );
});

interface StudentRotaDetailFooterProps {
    rota: StudentRota;
    viewModel: WeeklyRotaDetailsViewModel;
    closeCommand: ICommand;
}

const StudentRotaDetailFooter: React.FC<StudentRotaDetailFooterProps> = ({ rota, viewModel, closeCommand }) => (
    <Footer>
        <ButtonGroup>
            <ViewStudentDetailsButton command={viewModel.navigateToDetailCommand} commandParam={rota.studentId}>
                VIEW STUDENT DETAILS
            </ViewStudentDetailsButton>
            <Show if={viewModel.showSessionReportButton}>
                <SessionReportButton command={viewModel.navigateToSessionDetailCommand} commandParam={rota.studentSessionId} $hasAbsence={viewModel.hasAbsence}>
                    {viewModel.sessionReportButtonLabel}
                </SessionReportButton>
            </Show>
            <Button command={closeCommand} displayName={"RETURN TO ROTA"} paletteColor="secondary" />
        </ButtonGroup>
    </Footer>
);

export default StudentRotaDetailView;
